








































import Vue from 'vue';
export default Vue.extend({
    name: 'ArticleDialog',
    props: {
        title: {
            type: String,
            default: '',
        },
        body: {
            type: String,
            default: '',
        },
        img: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        height: 600,
        width: 600,
    }),
    computed: {
        hasHistory(): Boolean {
            // @ts-ignore
            return this.$interfaces.dialogModal.hasHistory();
        },
    },
    methods: {
        closeDialog() {
            // @ts-ignore
            this.$interfaces.dialogModal.getState().resolver.res();
        },
        handleResizeEvent() {
            this.height = window.innerHeight * 0.9;
            this.width = window.innerWidth;
        },
        stepBackHistory() {
            // @ts-ignore
            this.$interfaces.dialogModal.popState();
        },
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleResizeEvent);
        });
        this.handleResizeEvent();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResizeEvent);
    },
});
